import React from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export class Players extends React.Component {
    constructor(props) {
        super(props);

        this.onDelete = this.onDelete.bind(this);
        this.onAdmin = this.onAdmin.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    onAdmin(playerId) {
        this.props.socket.send(JSON.stringify({ kind: "grantAdmin", admin: this.props.players[playerId] }));
        this.props.onAdmin(this.props.players[playerId]);
    }

    onDelete(playerId) {
        this.props.socket.send(JSON.stringify({ kind: "kick", kicked: this.props.players[playerId] }));
        this.props.onKick(playerId);
    }

    onSelect(playerId) {
        this.props.socket.send(JSON.stringify({ kind: "selectJudge", judge: this.props.players[playerId] }));
        this.props.onChangeJudge(this.props.players[playerId]);
    }

    render() {
        let next = <div></div>;

        if (this.props.admin && this.props.players.length > 2) {
            next = <Button variant="primary" className="max-width" onClick={this.props.onPlay}>
                    Jouer
                </Button>;
        }

        let code = this.props.code.toString().padStart(6, "0");

        return (<>
            <div className="text-center margin-auto">
                <div className="text-muted pt-2">Code salon</div>
                <div className="code-header">{code}</div>
                <hr className="divider-sm" />
                {
                    this.props.players.map((player, index) => (<>
                        <PlayerDisplay
                            selected={this.props.selected == player}
                            onSelect={this.onSelect}
                            onDelete={this.onDelete}
                            onAdmin={this.onAdmin}
                            name={player}
                            judge={this.props.selected == player}
                            admin={this.props.admin}
                            self={player == this.props.self}
                            id={index}
                        />
                        <hr className="divider-sm" />
                    </>))
                }
                {next}
            </div>
        </>);
    }
}

class PlayerDisplay extends React.Component {
    render() {
        let buttonZone;

        if (this.props.admin && !this.props.self) {
            let kick = <div></div>;

            if (!this.props.judge) {
                kick = <Button variant="danger" className="mr-2" onClick={() => this.props.onDelete(this.props.id)}>
                    <i className="fas fa-times"></i>
                </Button>
            }

            buttonZone = <Col className="text-right">
                {kick}
                <Button variant="info" onClick={() => this.props.onAdmin(this.props.id)}>
                    <i className="fas fa-crown"></i>
                </Button>
            </Col>
        } else {
            buttonZone = <Col xs={1}></Col>
        }

        return <>
            <Row>
                <Col className="text-left center-vert max-width">
                    <Form.Check inline onChange={() => this.props.onSelect(this.props.id)} checked={this.props.selected} disabled={!this.props.admin} type="radio" name="guesser" id={`radio-${this.props.id}`} />
                    <Form.Label htmlFor={`radio-${this.props.id}`}>{this.props.name}</Form.Label></Col>
                {buttonZone}
            </Row>

        </>;
    }
}